import React from 'react';
import TextInput from "./TextInput";

const DateAndTimePicker = (props) => {
    return <TextInput InputLabelProps={{
        shrink: true,
    }}
                      type="datetime-local"
                      {...props} />
}

export default DateAndTimePicker;